import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import {
    Create,
    SimpleForm,
    TextInput,
    SelectInput,
    ReferenceInput,
    BooleanInput,
    required,
    email, NumberInput,
    minValue,
    maxValue
} from 'react-admin';
import { validatePrecision } from "../coins/utils/precisionValidate";
import { API_BASE } from '../dataProvider';
import { COUNTRY_LIST } from '../constants/countries';

const itemStyle = {
    width: '75%',
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: '8px'
}

export const validateEmail = [required(), email()];
export const validateRequired = [required()];


export const inputStyle = { width: '20em' }

const UserCreate = ({ permissions, ...props }) => {
    let parentUserCommissionRateSetting = JSON.parse(localStorage.getItem('BITFA:DASHBOARD:AUTH:commissionRateSetting'));

    const isAdmin = permissions === 'system_admin';
    const isOperator = (permissions === 'operator' || permissions === 'operator_staff');
    const isPromoter = (permissions === 'promoter' || permissions === 'promoter_staff');
    const [selectedUserType, setSelectedUserType] = useState('');
    const [revenueShares, setRevenueShares] = useState([
        { month: 24, rate: 1.5 },
        { month: 12, rate: 1}
    ]);

    useEffect(() => {
        const url = `${API_BASE}/accountinfo`;
        const getAuthToken = () => {
            return localStorage.getItem('BITFA:DASHBOARD:AUTH:TOKEN')
        }
        if (isOperator) {
            const token = getAuthToken();
            fetch(url, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
        }

    }, [])


    const handleUserTypeChange = (event) => {
        let s = '';
        for (let i in event) {
            if (i == "preventDefault") {
                break;
            }
            s += event[i];
        }

        setSelectedUserType(s)

    };

    const addRevenueShare = () => {
        setRevenueShares([...revenueShares, { month: "", rate: "" }]);
    };

    const removeRevenueShare = (index) => {
        if (revenueShares.length > 1) {
            const newShares = revenueShares.filter((_, i) => i !== index);
            setRevenueShares(newShares);
        }
    };

    const updateRevenueShare = (index, field, value) => {
        const newShares = [...revenueShares];
        newShares[index][field] = value;
        setRevenueShares(newShares);
    };

    const commonInputProps = {
        style: inputStyle,
    };

    const validatesUserCreation = (values) => {
        const errors = {};
        return errors;
    };

    return (
        <Create title="User" {...props}>
            <SimpleForm redirect="list" validate={validatesUserCreation}>
                <TextInput source="name" label="Username" validate={validateRequired}   {...commonInputProps} />
                <TextInput source="email" label="Email" validate={validateEmail} {...commonInputProps} />
                <TextInput source="phoneNumber" label="Phone Number"  {...commonInputProps} />
                <SelectInput source="country" label="Country" validate={validateRequired} choices={COUNTRY_LIST} {...commonInputProps} />
                <ReferenceInput
                    source="userType"
                    label="User Type"
                    reference="user/types"
                    validate={validateRequired}
                    onChange={handleUserTypeChange}
                    id="userType"
                >
                    <SelectInput defaultValue="store_owner" />
                </ReferenceInput>
                
                {selectedUserType === 'promoter' && (
                    <>
                        <NumberInput 
                            source="signOnBonusAmount" 
                            label="Sign-on Bonus Amount" 
                            validate={[required(), minValue(0)]} 
                            {...commonInputProps} 
                        />
                        
                        <div style={{ marginTop: '20px' }}>
                            <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>Revenue Share Settings</p>
                            {revenueShares.map((share, index) => (
                                <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                    <NumberInput
                                        source={`revenueShares[${index}].month`}
                                        label={`Month ${index + 1}`}
                                        defaultValue={share.month}
                                        validate={[required(), minValue(1)]}
                                        style={{ width: '10em', marginRight: '10px' }}
                                        onChange={(value) => updateRevenueShare(index, 'month', value)}
                                    />
                                    <NumberInput
                                        source={`revenueShares[${index}].rate`}
                                        label={`Rate ${index + 1} (%)`}
                                        defaultValue={share.rate}
                                        validate={[required(), minValue(0), maxValue(100)]}
                                        style={{ width: '10em', marginRight: '10px' }}
                                        onChange={(value) => updateRevenueShare(index, 'rate', value)}
                                    />
                                    <button 
                                        type="button" 
                                        onClick={() => removeRevenueShare(index)}
                                        style={{ 
                                            padding: '5px 10px', 
                                            backgroundColor: '#f44336', 
                                            color: 'white', 
                                            border: 'none', 
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            marginRight: '5px'
                                        }}
                                        disabled={revenueShares.length <= 1}
                                    >
                                        Remove
                                    </button>
                                </div>
                            ))}
                            <button 
                                type="button" 
                                onClick={addRevenueShare}
                                style={{ 
                                    padding: '8px 16px', 
                                    backgroundColor: '#4CAF50', 
                                    color: 'white', 
                                    border: 'none', 
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    marginTop: '10px'
                                }}
                            >
                                Add Revenue Share
                            </button>
                        </div>
                    </>
                )}

            </SimpleForm>
        </Create>
    );
};

export default UserCreate;

